export const formatShopifyProductByHandle = (response) => {
  const product = response.data ? response.data.productByHandle : response;

  // Flatten images
  const images = product.images.edges.map(edge => edge.node);

  // Flatten variants
  const variants = product.variants.edges.map(edge => edge.node);

  // Construct a more readable response
  return {
    id: product.id,
    createdAt: product.createdAt,
    updatedAt: product.updatedAt,
    descriptionHtml: product.descriptionHtml,
    description: product.description,
    handle: product.handle,
    tags: product.tags,
    productType: product.productType,
    title: product.title,
    vendor: product.vendor,
    publishedAt: product.publishedAt,
    onlineStoreUrl: product.onlineStoreUrl,
    requiresSellingPlan: product.requiresSellingPlan,
    featuredImage: product.featuredImage,
    options: product.options,
    favorites_count: product.favorites_count,
    product_details: product.product_details.filter(detail => detail !== null), // Remove null details
    images: images, // Flattened images array
    image: images[0],
    variants: variants // Flattened variants array
  };
}

export const formatShopifyProductsResponse = (response) => {
  const products = response.data.products ? response.data.products.edges.map(edge => edge.node) : response.data.nodes;
  return products.filter(product => product).map(product => formatShopifyProductByHandle(product));
}

export const formatShopifyCart = (cartData, userErrors)=>  {
  if (!cartData) {
    return {cart: null, userErrors: null};
  }
  console.log('cartData', cartData);
  return {cart: {
    id: cartData.id,
    checkoutUrl: cartData.checkoutUrl,
    buyerIdentity: cartData.buyerIdentity,
    totalQuantity: cartData.totalQuantity,
    appliedGiftCards: cartData.appliedGiftCards,
    attributes: cartData.attributes,
    cost: cartData.cost,
    createdAt: cartData.createdAt,
    note: cartData.note,
    updatedAt: cartData.updatedAt,
    discountCodes: cartData.discountCodes,
    discountAllocations: cartData.discountAllocations,
    deliveryGroups: cartData.deliveryGroups.edges.map(edge => edge.node),
    lines: cartData.lines.edges.map(edge => ({
      id: edge.node.id,
      attributes: edge.node.attributes,
      cost: edge.node.cost,
      quantity: edge.node.quantity,
      discountAllocations: edge.node.discountAllocations,
      sellingPlanAllocation: edge.node.sellingPlanAllocation ? {
        checkoutChargeAmount: edge.node.sellingPlanAllocation.checkoutChargeAmount,
        sellingPlan: edge.node.sellingPlanAllocation.sellingPlan
      } : null,
      merchandise: {
        product: {
          id: edge.node.merchandise.product.id,
          productType: edge.node.merchandise.product.productType,
          title: edge.node.merchandise.product.title,
          createdAt: edge.node.merchandise.product.createdAt,
          description: edge.node.merchandise.product.description,
          featuredImage: edge.node.merchandise.product.featuredImage,
          product_details: edge.node.merchandise.product.product_details.filter(detail => detail !== null),
          publishedAt: edge.node.merchandise.product.publishedAt,
          tags: edge.node.merchandise.product.tags,
          availableForSale: edge.node.merchandise.product.availableForSale,
          handle: edge.node.merchandise.product.handle,
          vendor: edge.node.merchandise.product.vendor,
          condition: edge.node.merchandise.product.condition,
        },
        id: edge.node.merchandise.id,
        availableForSale: edge.node.merchandise.availableForSale,
        barcode: edge.node.merchandise.barcode,
        image: edge.node.merchandise.image,
        price: edge.node.merchandise.price,
        quantityAvailable: edge.node.merchandise.quantityAvailable,
        sku: edge.node.merchandise.sku,
        title: edge.node.merchandise.title,
        taxable: edge.node.merchandise.taxable,
        unitPrice: edge.node.merchandise.unitPrice
      }
    }))
  }, userErrors: userErrors && userErrors.length > 0 ? userErrors : null};
}

export const splitArrayIntoChunks = (arr, chunkSize = 250) => {
  const result = [];
  for (let i = 0; i < arr.length; i += chunkSize) {
    const chunk = arr.slice(i, i + chunkSize);
    result.push(chunk);
  }
  return result;
}
